import { types, getParent } from 'mobx-state-tree';
import wager from './Wager'


const WagerList = types.model('WagerList', {
    wagers: types.array(wager),
    totalWagers: 0
}).actions(self => ({
    add(wager) {
        self.flashBetSlipHeader();
        self.wagers.push(wager);
        self.totalWagers = self.totalWagers + 1;
        getParent(self, 1).showBetSlip();
    },
    remove(wager) {
        self.wagers.splice(self.wagers.indexOf(wager), 1);
        self.totalWagers = self.totalWagers - 1;
    },
    flashBetSlipHeader() {
        document.getElementById("bet-slip-header").style.background = "rgba(255, 255, 255, 0.1)"
        setTimeout(
            function () {
                document.getElementById("bet-slip-header").style.background = "#05141f"
            }
            , 170);
    }
})).views(self => ({
    totalPotentialWinAmount() {
        return this.wagers.reduce((sum, wager) => sum + wager.total(), 0)
    },
    totalStakeAmount() {
        return this.wagers.reduce((sum, wager) => sum + wager.stake(), 0)
    },
    totalWagersAmount() {
        return this.totalWagers;
    }
}));

export default WagerList;


// WEBPACK FOOTER //
// ./src/stores/BetSlipStore/WagerList.js